
const apiUrl = {
    // Users
    getMeUser: "/api/me",
    getUsers: "/api/users",
    getUserDetail: "/api/users/$userId",
    getUserUsage: "/api/users/$userId/usage",
    getUserDevice: "/api/users/$userId/devices",
    getUserDeviceDetail: "",
    getUserPortalRemoteAccess: "/api/users/$userId/portal-remote-access",
    getUserStatus: "/api/users/$userId/statuses",
    postUser: "/api/users",
    postUserDeleteAllTextMessage: "/api/users/$userId/delete-all-text-messages",
    putUser: "/api/users/$userId",
    putMeUser: "/api/me",
    putMeUserChangePassword: "/api/me/password",
    putUserDevice: "/api/users/$userId/devices",
    putUserSuspendDevice: "/api/users/$userId/devices/$imei/suspend",
    putUserUnsuspendDevice: "/api/users/$userId/devices",
    putUserSwitchDevice: "/api/users/$userId/devices/$imei/switch",
    putUserDeactivateDevice: "/api/users/$userId/devices/$imei/deactivate",
    putUserPassword: "/api/users/$userId/password",
    putUserPortalPassword: "/api/users/$userId/portal-password",
    deleteUser: "/api/users/$userId",
    restoreUser: "/api/users/$userId:restore",
    sendMessage: "/api/users/:sendMessage",
    putResendWelcomeEmail: "/api/users/$userId/devices/$imei/resend-welcome-email",

    // Devices this.$root.apiUrl.
    getDevices: "/api/devices",
    getDeviceDetail: "/api/devices/$imei",
    getDeviceBeachMdmStatus: "/api/devices/$imei/beach-mdm-status",
    getDeviceLastFCMUpdate: "/api/devices/$imei/fcm-last-update",
    getRemoteDebugAccessToken: "/api/devices/remote-debug-access-token",
    getTerminalStream: "/device-debug/terminal",
    getDeviceFile: "/device-debug/file/download",
    postDeviceFile: "/device-debug/file/upload",
    getDeviceUsage: "/api/devices/$imei/usage",
    getDeviceUsers: "/api/devices/$imei/users",
    getDeviceSims: "/api/devices/$imei/sims",
    getDeviceSimDetail: "/api/devices/$imei/sims/$sim",
    getDeviceNotes: "/api/devices/$imei/notes",
    getDeviceTestResults: "/api/devices/$imei/test-results",
    getDeviceVersions: "/api/devices/$imei/versions",
    getSpeakerActivationCode: "/api/devices/$imei/activation-code",
    getSpeakerActivationCodeValidity: "/api/devices/$imei/activation-code-validity",
    generateAdminPassword: "/api/devices/:generateAdminPassword",
    postDeviceSim: "/api/devices/$imei/sims",
    postDeviceNotes: "/api/devices/$imei/notes",
    putDevice: "/api/devices/$imei",
    putDeviceRetire: "/api/devices/$imei/retire",
    putDeviceUnretire: "/api/devices/$imei/unretire",
    putDeviceReset: "/api/devices/$imei/reset",
    putDeviceIssueCommand: "/api/devices/$imei/issue-command",
    putDeviceDeactivateSim: "/api/devices/$imei/sims/$simNumber/deactivate",
    putSpeakerEmail: "/api/devices/$imei/speaker-email",
    putPortInNumber: "/api/devices/$imei/sims/$sim/port-in-number",
    putDeviceTransfer: "/api/devices/$imei/transfer",

    // Roles
    getRoles: "/api/roles",
    getRoleDetail: "/api/roles/$roleId",
    postRole: "/api/roles",
    putRole: "/api/roles/$roleId",

    // Permissions
    getPermissions: "/api/permissions",

    // Orgs
    getOrgs: "/api/organisations",
    getOrgDetail: "/api/organisations/$orgId",
    getOrgServices: "/api/organisations/$orgId/services",
    getOrgContacts: "/api/organisations/$orgId/contacts",
    postOrg: "/api/organisations",
    putOrg: "/api/organisations/$orgId",

    // Regions
    getRegions: "/api/regions",
    getSubRegions: "/api/regions/$regionId/sub",

    //SIM Card
    getSimcards: "/api/simcards",
    getSimcardDetail: "/api/simcards/$simNumber",
    postSimcards: "/api/simcards",
    putSimcard: "/api/simcards/$simNumber",
    putSimcardDeactivate: "/api/simcards/$simNumber/deactivate",

    // Logs
    getLogs: "/api/logs",

    // WIMP
    sendCommand: "/api/wimp/actions/$imei:issueCommand",
    getLastDeviceLocation: "/api/wimp/locations/$imei:lastLocation",
    getDeviceLocations: "/api/wimp/locations/$imei:getByImei",
    getDeviceActions: "/api/wimp/actions/$imei:getByImei",

    // Credentials
    getCredentials: "/api/credentials/users/$userId",
    getCredential: "/api/credentials/users/$userId/sources/$sourceId",
    postCredential: "/api/credentials/users/$userId",
    putCredential: "/api/credentials/users/$userId/sources/$sourceId",

    // Device Models
    getDeviceModels: "/api/deviceModels",
    getDeviceModelDetail: "/api/deviceModels/$model",
    postDeviceMode: "/api/deviceModels",
    putDeviceModel: "/api/deviceModels/$model",
    getDeviceModelOs: "/api/deviceModels/$model/os",
    getDeviceModelOsDetail: "/api/deviceModels/$model/os/$os",
    postDeviceModelOs: "/api/deviceModels/$model/os",
    putDeviceModelOs: "/api/deviceModels/$model/os/$os",

    // Mobile Plan
    getMobilePlans: "/api/mobilePlans",
    getMobilePlanDetail: "/api/mobilePlans/$mobilePlanId",
    postMobilePlan: "/api/mobilePlans",
    putMobilePlan: "/api/mobilePlans/$mobilePlanId",

    // Mobile Plan Refs
    getMobilePlanRefs: "/api/mobilePlans/ref",

    // Services
    getUserDeviceServices: "/api/userDeviceServices",
    getUserDeviceServiceDetail: "/api/userDeviceServices/$serviceId",
    getUserDeviceServiceReleaseHistory: "/api/userDeviceServices/$serviceId/release-history",
    postUserDeviceService: "/api/userDeviceServices",
    putUserDeviceService: "/api/userDeviceServices/$serviceId",
    // Services Refs
    getUserDeviceServiceStatus: "/api/userDeviceServices/status",

    // Survey
    getSurveys: "/api/surveys",
    getSurveyDetail: "/api/surveys/$surveyId",
    getSurveyQuestions: "/api/surveys/$surveyId/questions",
    getSurveyResponses: "/api/surveys/$surveyId/responses",
    postSurveys: "/api/surveys",
    postImportSurvey: "/api/surveys/import",
    putSurveys: "/api/surveys/$surveyId",

    // Credential Refs
    getCredentialRefs: "/api/credentials/ref",

    // Release Management
    getReleases: "/api/releases",
    getReleaseDetail: "/api/releases/$releaseId",
    getReleaseTemplateFiles: "/api/releases/template-files",
    getReleaseFiles: "/api/releases/$releaseId/files",
    getReleaseExport: "/api/releases/$releaseId/export",
    getReleaseBeachMdmPolicies: "/api/releases/beach-mdm/policies",
    postRelease: "/api/releases",
    postReleaseImport: "/api/releases/import",
    putRelease: "/api/releases/$releaseId",
    putReleaseFiles: "/api/releases/$releaseId/files",
    getUserDeviceServiceTemplates: "/api/userDeviceServices/$serviceId/templates",
    getUserDeviceServiceTemplateDocument: "/api/userDeviceServices/$serviceId/templates/$serviceTemplateId/document",
    getTemplates: "/api/templates",
    postTemplate: "/api/templates",
    postTemplateDocumentMetadata: "/api/templates/document-metadata",
    getTemplateDetail: "/api/templates/$templateId",
    putTemplate: "/api/templates/$templateId",
    deleteTemplate: "/api/templates/$templateId",
    getTemplateRender: "/api/templates/$templateId/render",
    postTemplateRender: "/api/templates/$templateId/render",
    getTemplateVariables: "/api/templates/$templateId/variables",

    // Release Management
    getServiceAccounts: "/api/serviceAccounts",
    postServiceAccounts: "/api/serviceAccounts",
    putServiceAccountsChangePassword: "/api/serviceAccounts/$userId:changePassword",

    // Zoho Voice Backup
    getZohoVoiceBackup: "/api/zohoVoices/:download",

    // Product Catalog
    getProducts: "/api/products",
    getProductsForSale: "/api/products/for-sale",
    getProductsArchived: "/api/products/archived",
    getProductDetail: "/api/products/$productId",
    getProductChargebeePlan: "/api/products/chargebee/plans",
    getProductChargebeeAddon: "/api/products/chargebee/addons",
    getProductChargebeeCoupon: "/api/products/chargebee/coupons",
    postProducts: "/api/products",
    putProducts: "/api/products/$productId",
    putProductArchive: "/api/products/$productId:archive",
    putProductRestore: "/api/products/$productId:restore",

    // Chargebee
    getChargebeeCustomers: "/api/chargebee/customers",
    postChargebeeTempUser: "/api/chargebee/subscriptions:createTempUser",
    postChargebeeSubscriptions: "/api/chargebee/subscriptions",

    // Job Monitors
    getJobMonitors: "/api/monitors/jobs",
    putJobMonitors: "/api/monitors/jobs/$jobId",

    // Banners
    getBanners: "/api/banners",
    getBannerDetail: "/api/banners/$bannerId",
    postBanner: "/api/banners",
    postDuplicateBanner: "/api/banners/$bannerId:duplicate",
    putBanner: "/api/banners/$bannerId",
}

export default apiUrl
